// ─── AI 관리자 - 질의 현황 페이지 ────────────────────────────────────────────
import React from 'react';
import { Button } from 'react-bootstrap';
import { WifiOff } from 'lucide-react';
import { useAdminHistory } from './hooks/useAdminHistory';
import InquiriesSection from './components/inquiries/InquiriesSection';

const AIAdminInquiriesPage = () => {
  const { rows, isLoading, isError, error, refetch, isFetching } = useAdminHistory();

  if (isLoading && !rows.length) {
    return (
      <div className="flex min-h-[280px] flex-col items-center justify-center gap-3 text-gray-500">
        <div className="h-8 w-8 animate-spin rounded-full border-2 border-sb-primary border-t-transparent" />
        <p className="text-sm">DB 이력을 불러오는 중…</p>
      </div>
    );
  }

  if (isError) {
    return (
      <div className="flex min-h-[280px] flex-col items-center justify-center gap-3 px-6 text-center">
        <WifiOff className="h-1 w-1 text-gray-300" />
        <p className="text-sm font-semibold text-gray-800">이력을 불러올 수 없습니다</p>
        <p className="max-w-md text-xs text-gray-500">{error?.message || 'API 오류'}</p>
        <Button variant="primary" className="border-0 bg-sb-primary" size="sm" onClick={() => refetch()}>
          다시 시도
        </Button>
      </div>
    );
  }

  return (
    <div className="p-6 pb-10 md:p-8">
      <header className="mb-6 flex flex-wrap items-start justify-between gap-4 border-b border-gray-100 pb-4">
        <div>
          <h1 className="text-2xl font-bold tracking-tight text-sb-header">질의 현황</h1>
          <p className="mt-1 text-base text-gray-500">산업안전보건법 AI 챗봇 운영 관리</p>
          {isFetching && !isLoading && <p className="mt-2 text-xs text-sb-primary">갱신 중…</p>}
        </div>
        <div className="flex flex-wrap items-center gap-3">
          <span className="text-sm text-gray-400">
            {new Date().toLocaleDateString('ko-KR', { year: 'numeric', month: 'long', day: 'numeric' })}
          </span>
          <Button variant="outline-secondary" size="sm" className="text-xs" onClick={() => refetch()}>
            새로고침
          </Button>
        </div>
      </header>

      <InquiriesSection rows={rows} refetch={refetch} />
    </div>
  );
};

export default AIAdminInquiriesPage;
